import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $slider = $sectionInstance.find( '.js-cartoons-featured-slider' );
		new Swiper( $slider[0], {
			slidesPerView: 1,
			spaceBetween: 20,
			speed: 1000,
			loop: true,
			pagination: {
				el: $sectionInstance.find( '.swiper-pagination' )[0],
				clickable: true,
			},
			navigation: {
				nextEl: $sectionInstance.find( '.swiper-button-next' )[0],
				prevEl: $sectionInstance.find( '.swiper-button-prev' )[0],
			},
		} );
	} );
};

app.loadBlock( initBlock, 'cartoons', '.section-cartoons' );

if ( module.hot ) {
	module.hot.accept();
}
